import { select } from '@wordpress/data';
import { store as coreDataStore } from '@wordpress/core-data';

/**
 * Returns the color used for Icon Color in the block editor.
 */
export function getBlockIconColor() {
    return '#f47422';
}

/**
 * Returns the icon SVG element enhanced with color props used in the block editor.
 *
 * @param {string} icon Icon SVG object represents `settings.icon` wrapped in color props.
 */
export function setIconColorProps( icon ) {
    // Icon is immutable. We can spread the object to clone it with new color props.
    return {
        ...icon,
        props: {
            ...{ ...icon.props },
            ...{ style: { color: getBlockIconColor() } },
        },
    };
}

/**
 * Component build the image based on the image gutenberg object. Also this image will contains srcset created by WP
 *
 * @param {Object} props Contains list of props that could be passed to component
 * @return {JSX.Element} Returns an <img> tag
 * @class
 */
export const AmplifyImage = ( props ) => {
    const { image } = props;
    const { id, url, alt, sizes } = image;
    const imgClassName = `wp-image-${ id }`;

    return (
        <img
            className={ imgClassName }
            src={ url }
            alt={ alt }
            width={ sizes && sizes.width }
            height={ sizes && sizes.height }
        />
    );
};

/**
 * Get list of nested blocks
 *
 * @param {Array} blocks List of Gutenberg blocks
 */
export const getNestedTemplate = ( blocks ) => {
    return blocks.map( ( block ) => {
        const innerTemplate = block.innerBlocks.length
            ? getNestedTemplate( block.innerBlocks )
            : [];
        return [ block.name, block.attributes, innerTemplate ];
    } );
};

/**
 * Remove empty blocks
 *
 * @param {Array} blocks of Gutenberg blocks
 */
export const clearEmptyBlocks = ( blocks ) => {
    return blocks.filter( ( item, index, self ) => {
        if ( item.innerBlocks.length === 0 ) {
            return (
                index ===
                self.findIndex(
                    ( other ) =>
                        other.attributes.content === item.attributes.content
                )
            );
        }
        return clearEmptyBlocks( item.innerBlocks );
    } );
};

export function getLoopInfo( query ) {
    const initialData = {
        isLoop: false,
        postType: '',
        query: {},
        taxonomies: [],
    };

    if ( query === undefined ) {
        return initialData;
    }

    if ( query.hasOwnProperty( 'postType' ) ) {
        const postTypeEntity = select( coreDataStore ).getPostType(
            query.postType
        );

        if ( 'undefined' === typeof postTypeEntity ) {
            return initialData;
        }

        return {
            isLoop: true,
            restNamespace: postTypeEntity.rest_namespace,
            postType: postTypeEntity.rest_base,
            query,
            taxonomies: postTypeEntity.taxonomies,
        };
    }
}

export function mergeFormData( currentFormData, newFormData ) {
    const mergedFormData = new FormData();

    for ( const [ key, value ] of currentFormData.entries() ) {
        mergedFormData.append( key, value );
    }

    for ( const [ key, value ] of newFormData.entries() ) {
        mergedFormData.append( key, value );
    }

    return mergedFormData;
}

/**
 * Checks whether the user agent is safari or not.
 */
export function isSafariBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
        userAgent.includes( 'safari' ) &&
        ! userAgent.includes( 'chrome' ) && // Chrome
        ! userAgent.includes( 'crios' ) && // Chrome on iOS
        ! userAgent.includes( 'fxios' ) && // Firefox on iOS
        ! userAgent.includes( 'edgios' ) && // Edge on iOS
        ! userAgent.includes( 'opr' ) && // Opera
        ! userAgent.includes( 'android' ) // Any Android browser
    );
}
